import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path };
/////////////////////////////////////////////////////////////////////////////////

export function updateNumeroDoc(urlTipoConta, idConta, payload) {
  return httpService.put({...args, path: `${urlTipoConta}/updateNumeroDoc/${idConta}`}, payload);
}

export function attachFiles(urlTipoConta, contaId, payload) {
  return httpService.putAttachFiles({ ...args, path: urlTipoConta, args: `/attachFiles/${contaId}` }, payload);
}

export function deleteAttachFiles(urlTipoConta, contaId, filesIdList) {
  return httpService.putDeleteFiles({ ...args, path: urlTipoConta, args: `/deleteFiles/${contaId}` }, filesIdList);
}
